import { createSelectors } from "services/src/utilities"
import { create } from "zustand"
import { devtools } from "zustand/middleware"
import { immer } from "zustand/middleware/immer"

export enum NavigationViews {
    Base = "Base",
    Root = "Root",
    Org = "Organization",
    BMA = "Brewmenu",
    PP = "Performance Platform",
    MMB = "Market My Brewery",
    BrewKnowledge = "BrewKnowledge"
}

interface IRootNavigationValues {
    currentNavView: NavigationViews
    slideNavIsOpen: boolean
    navIsExpanded: boolean
    navIsHidden: boolean
    showNavControls: boolean
}

export const defaultValues: IRootNavigationValues = {
    currentNavView: NavigationViews.Base,
    slideNavIsOpen: false,
    navIsExpanded: false,
    showNavControls: true,
    navIsHidden: false
}

interface IrootNavigationState extends IRootNavigationValues {
    setCurrentNavView: (view: NavigationViews) => void
    toggleSideNav: () => void
    toggleExpandedNav: () => void
    setExpandedNav: (expanded: boolean) => void
    setNavIsHidden: (hide: boolean) => void
    setShowNavControls: (show: boolean) => void
}

export const rootNavigationState = createSelectors(
    create<IrootNavigationState>()(
        devtools(
            immer((set, get) => ({
                ...defaultValues,
                setCurrentNavView: (view: NavigationViews) => {
                    set({ currentNavView: view })
                },
                toggleSideNav: () => {
                    set((state) => ({ slideNavIsOpen: !state.slideNavIsOpen }))
                },
                toggleExpandedNav: () => set((state) => ({ navIsExpanded: !state.navIsExpanded })),
                setExpandedNav: (expanded) => set({ navIsExpanded: expanded }),
                setNavIsHidden: (navIsHidden) => set({ navIsHidden }),
                setShowNavControls: (show: boolean) => set({ showNavControls: show })
            })),
            { name: "rootNavigationState" }
        )
    )
)
